import { useEffect, useState } from "react";
import { useFetchFeature } from "../../common/utils/features";

interface FeatureSettings {
    src: string;
    "cp-key": string;
    "image-src"?: string;
    text?: string;
}

interface Feature {
    feature: string;
    enabled: boolean;
    settings: FeatureSettings;
}

export default function FacilitiLoader() {
    const { enabled, settings }: Feature = useFetchFeature("faciliti");
    const src = settings?.["script-url"];
    const identifier = settings?.["cp-key"];
    const [scriptLoaded, setScriptLoaded] = useState(false);

    useEffect(() => {
        if (!scriptLoaded && !!document.head.querySelector("script#faciliti")) {
            setScriptLoaded(true);
            return;
        }
        if (enabled && identifier && src && !scriptLoaded) {
            //Setup Facil'iti
            const fs = document.createElement("script");
            fs.type = "text/javascript";
            fs.id = "faciliti";
            fs.src = src;
            //Set custom data attributes to use in the faciliti button

            fs.dataset.applicationIdentifier = identifier;
            fs.dataset.popinPosition = "left";
            document.head.appendChild(fs);

            setScriptLoaded(true);
        }
    }, [enabled, identifier, src, scriptLoaded, settings]);
    return null;
}
